$ = jQuery.noConflict()
$ ->
	init()

init = ->

	# Global JS
	App.init()

	# Sliders
	if $('[slick]').length
		Slider.init()

	# Block Metier Desc
	if $('.block-metier-desc').length
		MetierDesc.init()

	# Bloc Histoire (page groupe - presentation)
	if $('.block-histoire').length
		Histoire.init()

	# Bloc Chiffres (page groupe - chiffres cles)
	if $('.block-chiffres').length
		Chiffres.init()

	# Bloc Implantation (page groupe - implantation)
	if $('.block-implantation').length
		Implantation.init()

	# Single article
	if $('.page-article .article-actu').length
		Article.init()

	# Contact
	if('.page-contact').length
		Contact.init()

destroy = ->
	App.destroy()
